import React from 'react'
import { Evidence } from './Evidence'

export const EvidenceContainer = ({ calls, session_id }) => {
  return (
    <div className="evidence-container">
      {calls.map((call) => {
        return (
          <div key={call.call_id}>
            <Evidence call={call} dynsight_session_id={session_id} />
          </div>
        )
      })}
    </div>
  )
}
